import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-MetrikaColoredShape",
  "use": "svg-icon-MetrikaColoredShape-usage",
  "viewBox": "0 0 400 384",
  "content": "<symbol viewBox=\"0 0 400 384\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-MetrikaColoredShape\"><path fill=\"#F33\" d=\"M.103 245.623h122.771V383.74H.103z\" /><path fill=\"#07F\" d=\"M138.22 138.198h122.771v245.541H138.22z\" /><path fill=\"#FC0\" d=\"M276.337.081h122.771v383.658H276.337z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol